export const palette = {
	common: {
		white: "#D4D9D1",
		black: "#021A15",
	},
	primary: {
		main: "#2A4038",
		light: "#47605A",
		lighter: "#B1BBB3",
		dark: "#06211B",
		darker: "#021A15",
		contrast: "#D4D9D1",
	},
	secondary: {
		main: "#647D77",
		light: "#889A92",
		lighter: "#D4D9D1",
		dark: "#47605A",
		darker: "#2A4038",
	},
	text: {
		primary: "#021A15",
		disabled: "#647D77",
		main: "#06211B",
		light: "#47605A",
		accentMain: "#889A92",
		accentLight: "#B1BBB3",
	},
	success: {
		main: "#2A4038",
		light: "#647D77",
		contrastText: "#D4D9D1",
	},
	info: {
		main: "#47605A",
		contrastText: "#B1BBB3",
	},
	error: {
		main: "#A24B43",
		light: "#C36C64",
		contrastText: "#D4D9D1",
	},
	grey: {
		0: "#FFFFFF",
		25: "#F6F7F5",
		50: "#EDF0EC",
		100: "#D4D9D1",
		150: "#C3C9C4",
		200: "#B1BBB3",
		250: "#9CAAA1",
		300: "#889A92",
		400: "#647D77",
		600: "#47605A",
		700: "#2A4038",
		800: "#06211B",
	},
	divider: "#647D77",
};
